<div class="mx-3.5">
  <div
    *ngIf="!isTimeline"
    class="tr table-header flex px-2">
    <div class="column {{ mainColumnClass }}">
      <span class="info-row-title">Item name</span>
    </div>
    <div
      class="column one--column"
      *ngIf="scopeElementsService.userColumns.DELIVERY_STATUS.isVisible()">
      <span>Delivery status</span>
    </div>
    <div
      class="column one--column"
      *ngIf="scopeElementsService.userColumns.CREATED_BY.selected">
      <span>Created by</span>
    </div>
    <div
      class="column one--column"
      *ngIf="scopeElementsService.userColumns.OWNER.selected">
      <span>Owner</span>
    </div>
    <div
      class="column one--column"
      *ngIf="scopeElementsService.userColumns.DATE_CREATED.selected">
      <span>Date created</span>
    </div>
    <div
      class="column one--column"
      *ngIf="scopeElementsService.userColumns.QUANTITY.selected">
      <span>Quantity</span>
    </div>
    <div
      class="column one--column"
      *ngIf="
        scopeElementsService.userColumns.START_DATE.selected &&
        scopeElementsService.userColumns.START_DATE.isVisibleInList()
      ">
      <span class="info-row-title">Start date</span>
    </div>
    <div
      class="column one--column"
      *ngIf="scopeElementsService.userColumns.LAST_EDITED.selected">
      <span>Last edited</span>
    </div>
    <div
      class="column one--column"
      *ngIf="
        scopeElementsService.userColumns.END_DATE.selected &&
        scopeElementsService.userColumns.END_DATE.isVisibleInList()
      ">
      <span class="info-row-title">End date</span>
    </div>
    <div
      class="column one--column"
      *ngIf="scopeElementsService.userColumns.MARK_UP.selected">
      <span>Markup</span>
    </div>
    <div
      class="column one--column"
      *ngIf="scopeElementsService.userColumns.PROFIT.selected">
      <span>Profit</span>
    </div>
    <div
      class="column one--column"
      *ngIf="scopeElementsService.userColumns.SCOPEMARK_HOURS.selected">
      <span isEllipsisActive>{{ 'scope_mark' | lang }} hours</span>
    </div>
    <div
      class="column one--column"
      *ngIf="scopeElementsService.userColumns.SCOPEMARK_PRICE.selected">
      <span isEllipsisActive>{{ 'scope_mark' | lang }} price</span>
    </div>
    <div
      class="column one--column"
      *ngIf="scopeElementsService.userColumns.AGENCY_HOURS.selected">
      <span isEllipsisActive>{{ 'agency' | lang }} hours</span>
    </div>
    <div
      class="column one--column"
      *ngIf="scopeElementsService.userColumns.BUDGET.selected">
      <span>{{ 'budget' | lang }}</span>
    </div>
    <div
      class="column one--column"
      *ngIf="scopeElementsService.userColumns.BALANCE.selected">
      <span>Balance</span>
    </div>
    <div
      class="column one--column"
      *ngIf="scopeElementsService.userColumns.AGENCY_PRICE.selected">
      <span
        isEllipsisActive
        *ngIf="!scopeVersion.identity.costPlus">
        {{ 'agency' | lang }} price
      </span>
      <span
        isEllipsisActive
        *ngIf="scopeVersion.identity.costPlus">
        Cost plus price
      </span>
    </div>
    <div class="column one--column toggle-list-content">
      <scope-ui-toggle-list
        (onTogglePref)="onToggleScopePreference($event)"
        [preferences]="scopeElementsService.userColumnsPrefsArray"
        [maxSelected]="9">
      </scope-ui-toggle-list>
    </div>
  </div>

  <div
    *ngIf="isTimeline"
    class="tr table-header flex px-1">
    <div class="column {{ mainColumnClass }}">
      <span class="info-row-title">Item name</span>
    </div>
    <div class="column three--columns">
      <span>{{ 'agency' | lang }} hours</span>
    </div>
    <div class="column three--columns">
      <span>{{ 'agency' | lang }} price</span>
    </div>
  </div>
</div>
<div
  class="tbody table-content mt-2 {{ isTimeline ? 'timeline-view' : '' }}"
  [ngClass]="{ 'drag-target': sectionDragging }"
  *ngIf="sortedSections?.length"
  cdkDropList
  [cdkDropListData]="sortedSections"
  [cdkDropListDisabled]="!scopeApprovalFlowService.isScopeEditable(scopeVersion)"
  (cdkDropListDropped)="dropSection($event)"
  infinite-scroll
  [scrollWindow]="false"
  [fromRoot]="true"
  [infiniteScrollContainer]="'.main-container'"
  [infiniteScrollDistance]="1.5"
  [infiniteScrollThrottle]="0"
  (scrolled)="getSections()">
  <div
    *ngFor="let section of sortedSections; trackBy: trackById"
    class="item-loader-container"
    cdkDrag
    [cdkDragData]="section"
    [cdkDragDisabled]="scopeTabService.disableDragging"
    (cdkDragStarted)="sectionDragging = true"
    (cdkDragEnded)="sectionDragging = false">
    <mat-icon class="material-symbols-rounded drag-indicator">drag_indicator</mat-icon>
    <div
      *ngIf="sectionLoadingMap$(section.id) | async"
      class="item-loader">
      <img
        src="/assets/icons/loading.svg"
        alt="loading"
        class="icon-spinner" />
    </div>

    <scope-section-row
      class="tr section-row flex flex-col mat-elevation-z0"
      [ngClass]="{
        selected: scopeTabService.sectionSelectedStates[section.id] || section.id == scopeTabService.dragTargetId,
      }"
      [section]="section"
      [feeMenuOptions]="feeMenuOptions"
      [deliverableMenuOptions]="deliverableMenuOptions"
      [componentMenuOptions]="componentMenuOptions"
      [currentRatecard]="currentRatecard"
      [sectionSelectedStates]="scopeTabService.sectionSelectedStates$ | async"
      [cdnConfig]="cdnConfig"
      [tableConfig]="getDeliverablesTableConfig(section.id)"
      (mouseenter)="onDragEnter(section)"
      (onDropDeliverable)="dropDeliverable($event.event, $event.section)"
      (onAddSectionFee)="addSectionFee($event)"
      (onDeleteSection)="deleteSection($event)"
      (onFetchDeliverable)="fetchDeliverable($event)"
      (onUpdateDeliverable)="updateDeliverable($event)"
      (onUpdateComponent)="updateComponent($event)"
      (onUpdateFeeItem)="updateFeeItem($event)"
      (onUpdateRole)="updateRole($event)"
      (onUpdateDeliverableTpc)="updateDeliverableTpc($event)"
      (onUpdateComponentTpc)="updateComponentTpc($event)"
      (onUpdateDeliverableSectionTpc)="updateDeliverableSectionTpc($event)"
      (onReorderDeliverableTpcs)="reorderDeliverableTpcs($event)"
      (onReorderComponentTpcs)="reorderComponentTpcs($event)"
      (onReorderDeliverableSectionTpcs)="reorderDeliverableSectionTpcs($event)"
      (onAcceptDeliverable)="acceptDeliverable($event)"
      (onRejectDeliverable)="rejectDeliverable($event)"
      (onAddComponentFee)="addComponentFee($event)"
      (onOverrideComponentQuantity)="overrideQuantity($event)"
      (onOverrideRateCardRoleHours)="overrideRateCardRoleHours($event)"
      (onMoveComponent)="onMoveComponent.emit($event)"
      (onMoveComponentOutsideDeliverable)="onMoveComponentOutsideDeliverable.emit($event)"
      (onScrolledDown)="getSectionDeliverables(section.id)">
    </scope-section-row>
  </div>
</div>

<div
  *ngIf="(isSectionsLoading$ | async) && !(isDeliverablesLoading$ | async)"
  class="sections-loader">
  <img
    src="/assets/icons/loading-dark.svg"
    alt="loading"
    class="icon-spinner" />
</div>

<scope-deliverables
  class="tbody table-content mt-2 {{ isTimeline ? 'timeline-view' : '' }}"
  [config]="getDeliverablesTableConfig()"
  [deliverables]="sortedDefaultSectionDeliverables"
  [deliverableMenuOptions]="deliverableMenuOptions"
  [componentMenuOptions]="componentMenuOptions"
  [feeMenuOptions]="feeMenuOptions"
  [level]="1"
  [cdnConfig]="cdnConfig"
  (onExpandDeliverable)="fetchDeliverable($event.deliverableId)"
  (onUpdateDeliverable)="updateDeliverable($event)"
  (onUpdateComponent)="updateComponent($event)"
  (onUpdateFeeItem)="updateFeeItem($event)"
  (onUpdateRole)="updateRole($event)"
  (onUpdateDeliverableTpc)="updateDeliverableTpc($event)"
  (onUpdateComponentTpc)="updateComponentTpc($event)"
  (onUpdateDeliverableSectionTpc)="updateDeliverableSectionTpc($event)"
  (onReorderDeliverableTpcs)="reorderDeliverableTpcs($event)"
  (onReorderComponentTpcs)="reorderComponentTpcs($event)"
  (onReorderDeliverableSectionTpcs)="reorderDeliverableSectionTpcs($event)"
  (onAcceptDeliverable)="acceptDeliverable($event)"
  (onRejectDeliverable)="rejectDeliverable($event)"
  (onDropDeliverable)="dropDeliverable($event.event, $event.section)"
  (onOverrideComponentQuantity)="overrideQuantity($event)"
  (onOverrideRateCardRoleHours)="overrideRateCardRoleHours($event)"
  (onMoveComponent)="onMoveComponent.emit($event)"
  (onMoveComponentOutsideDeliverable)="onMoveComponentOutsideDeliverable.emit($event)"
  (onScrolledDown)="getDeliverables()" />
